import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    compare1: null,
    compare2: null,
    compareInputTab: "audience",
    compareResultTab: "deepdive"
};
const insights = createSlice({
    name: "insights",
    initialState: { ...initialState },
    reducers: {
        setCompare1: (state, action) => {
            state.compare1 = action.payload;
        },
        setCompare2: (state, action) => {
            state.compare2 = action.payload;
        },
        setCompareInputTab: (state, action) => {
            state.compareInputTab = action.payload;
        },
        setCompareResultTab: (state, action) => {
            state.compareResultTab = action.payload;
        },
        resetInsightsState: (state) => {
            state.compare1 = null;
            state.compare2 = null;
            state.compareInputTab = "audience";
            state.compareResultTab = "deepdive";
        }
    }
});

const { reducer, actions } = insights;
export const {
    setCompare1,
    setCompare2,
    setCompareInputTab,
    setCompareResultTab,
    resetInsightsState
} = actions;
export default reducer;
